import React from "react";

const InputFeedback = ({ children }) => {

  if ( !children ) {
    return null;
  }

  return <div className="alert alert-danger">
    {children}
  </div>;
};

export default InputFeedback;
